export enum IcpProviderEnum {
    FIVE_BY_FIVE = 'FIVE_BY_FIVE',
    BOMBORA = 'BOMBORA',
}
